module.exports = __webpack_public_path__ + "media/images/emoticons/shoe-dc5aa8e4f7e18d5931e492b97448d0d1.gif";